const trainers = [
  { 
    name: 'NARAYAN CHHETRI', 
    role: 'Professional Coach', 
    image: '/images/krishna.jpg',
    description: "Narayan is a professional coach with over 10 years of experience in bodybuilding and strength training. He has trained hundreds of clients to achieve their dream physiques through disciplined training, structured programs, and strong mentorship."
  },
  { 
    name: 'RUDRA THAPA', 
    role: 'Fitness Instructor', 
    image: '/images/rudra.jpg',
    description: "Rudra is a certified fitness instructor specializing in HIIT and functional training. With a passion for endurance, mobility, and overall wellness, he motivates clients to stay consistent while enjoying every step of their fitness journey."
  },
];

const Trainers = () => {
  return (
    <section className="py-20 bg-gray-100">
      <div className="container mx-auto px-8 md:px-24 space-y-24">
        {trainers.map((trainer, idx) => (
          <div
            key={idx}
            className={`flex flex-col md:flex-row items-center gap-20 rounded-3xl shadow-xl p-10 bg-gradient-to-r from-white to-gray-100 ${
              idx % 2 === 1 ? "md:flex-row-reverse" : ""
            }`}
          >
            {/* Image */}
            <div className="flex-shrink-0">
              <img
                src={trainer.image}
                alt={trainer.name}
                className="w-80 h-[460px] object-cover rounded-2xl shadow-2xl"
              />
            </div>

            {/* Details */}
            <div className="text-center md:text-left max-w-lg">
              <h3 className="text-4xl font-extrabold mb-4">{trainer.name}</h3> {/* Bigger + bolder */}
              <p className="text-2xl text-gray-800 mb-6">{trainer.role}</p>   {/* Slightly larger role */}
              <p className="text-lg text-gray-700 leading-relaxed">          {/* Larger description */}
                {trainer.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};


export default Trainers;
